module.exports = "/_next/static/images/bf3857bcc3134ef4524df1cf10992af7-woman-holding-card-smiling-2@mobile320.png";